<template>
  <div>
    <el-row>
      <el-col :span="12" class="mt-2 mb-2">
        <h3>Member Details</h3>
      </el-col>
      <el-col :span="12" class="d-flex flex-justify-end mt-2 mb-2">
        <el-button type="default" @click="back">Go back</el-button>
      </el-col>
    </el-row>
    <MemberDetailsComponent :member="member" />
    <div class="d-flex gap-10 flex-justify-end btn">
      <el-button
        type="secondary"
        @click="changeLogsDialogVisible = true"
      >
      Change Log
      <el-tooltip content="This is a list of any changes to the member details in database" placement="top">
        <i class="el-icon-info"></i>
      </el-tooltip>
    </el-button>
      <el-button type="primary" @click="downloadDialog = true">Download</el-button>
    </div>
    <el-tabs v-model="tab" class="tab-container">
      <el-tab-pane label="Details" name="details" :lazy="true" >
        <member-detail-form v-model="member" :key="key" :changeLogs="changeLogs" @lock="lockUser" @unlock="unlockUser"/>
      </el-tab-pane>
      <el-tab-pane label="Registration History" name="rego-history" :lazy="true">
        <registration-history v-model="registrations" :member="member" />
      </el-tab-pane>
      <el-tab-pane label="Store Purchase History" name="store-purchase-history" :lazy="true">
        <store-purchase-history v-model="registrations" :member="member" />
      </el-tab-pane>
      <el-tab-pane label="Teams" name="team" :lazy="true">
        <teams v-model="member" />
      </el-tab-pane>
      <el-tab-pane v-if="clearance <= roles.clubAdmin" label="Accreditations" name="accreditations" lazy>
        <Accreditations v-model="member" />
      </el-tab-pane>
      <el-tab-pane label="Performance" name="performances" lazy>
        <Performances v-model="member" />
      </el-tab-pane>
      <el-tab-pane label="Entity" name="entity" lazy>
        <entity v-model="member" />
      </el-tab-pane>
      <el-tab-pane label="Communication Preferences" name="communication-preferences" lazy>
        <CommunicationPreferences v-model="member" />
      </el-tab-pane>
      <!-- tab for change logs -->
      <!-- <el-tab-pane label="Change Logs" name="change-logs" lazy>
        <change-logs v-model="changeLogs" />
      </el-tab-pane> -->
    </el-tabs>
    <el-dialog
      title="Download User History"
      :visible.sync="downloadDialog"
      width="30%"
      :before-close="handleClose">
      <span>Select from the options below:</span>
      <el-form ref="form" :model="download" :rules="rules" label-position="top">
        <el-form-item prop="download.details" label="">
            <div><el-checkbox v-model="download.details" :label="true" >Details</el-checkbox> </div>
            <div><el-checkbox v-model="download.regoHistory" :label="true" >Registration History</el-checkbox> </div>
            <div><el-checkbox v-model="download.accreditations" :label="true" >Accreditation</el-checkbox> </div>
            <div><el-checkbox v-model="download.teams" :label="true" >Teams</el-checkbox> </div>
            <div><el-checkbox v-model="download.performance" :label="true" >Performance</el-checkbox> </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downloadDialog = false">Close</el-button>
        <el-button type="primary" @click="downloadPDF">Download</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Change Logs"
      :visible.sync="changeLogsDialogVisible"
      width="75%"
      >
      <change-logs v-model="changeLogs" />
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
// eslint-disable-next-line import/no-duplicates
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
// eslint-disable-next-line import/no-duplicates
import autoTable from 'pdfmake/build/vfs_fonts.js';
import { roles } from '@/utils/roles';
import { clientsAdditionalDetails } from '@/utils/client-additional-details.js';
import { timedate } from '@/utils/timedate';

export default {
  props: ['selectedTab', 'fromAccreditation'],
  name: 'MemberDetails',
  components: {
    MemberDetailForm: () => import('./components/MemberDetailForm.vue'),
    RegistrationHistory: () => import('./components/RegistrationHistory.vue'),
    StorePurchaseHistory: () => import('./components/StorePurchaseHistory.vue'),
    Teams: () => import('./components/Teams.vue'),
    Accreditations: () => import('./components/Accreditations.vue'),
    Performances: () => import('./components/Performances.vue'),
    MemberDetailsComponent: () => import('./components/MemberDetailsComponent.vue'),
    Entity: () => import('./components/Entity.vue'),
    CommunicationPreferences: () => import('./components/CommunicationPreferences.vue'),
    ChangeLogs: () => import('./components/ChangeLogs.vue'),
  },
  data() {
    return {
      roles,
      clientsAdditionalDetails,
      tab: 'details',
      registrations: [],
      key: 0,
      member: undefined,
      downloadDialog: undefined,
      download: {
        details: true,
        regoHistory: true,
        teams: true,
        accreditations: true,
        performance: true
      },
      teams: [],
      accreditations: [],
      pefromances: [],
      scoringEvents: [],
      playerMovements: [],
      changeLogs: [],
      changeLogsDialogVisible: false
    };
  },
  async mounted() {
    const { id } = this.$route.params;
    const { tabName } = this.$route.params;
    this.$store.commit('loading', true);
    this.$http.get(`/assemble/api/v1/admin/members/${id}/refunds`)
      .then((res) => {
        const { member, registrations } = res.data.data;
        const { changeLogs } = member;
        if (_.isUndefined(_.get(member, 'meta.showImg'))) {
          member.meta = { ...member.meta, showImg: true };
        }
        this.member = _.merge({}, this.member, member);
        this.$store.commit('app/setHeaderName', `Members - ${_.get(this, 'member.profile.firstName')} ${_.get(this, 'member.profile.lastName')}`);
        this.registrations = _.map(registrations, (data) => ({ ...data, results: data.results ? Object.assign({}, ...data.results) : {} }));
        if (tabName) {
          this.tab = tabName;
        } else this.tab = this.selectedTab ? this.selectedTab : 'details';
        this.loadTeams(member._id);
        this.loadAccreditations(member._id);
        this.loadPerformances(member._id);
        this.changeLogs = changeLogs;
        console.log('changeLogs', this.changeLogs);
        this.$store.commit('loading', false);
        this.key++;
      }).catch((error) => {
        this.$message.error(error.response.data.message);
        this.$store.commit('loading', false);
      });
  },
  methods: {
    back() {
      if (this.$route.params.accreditation) {
        this.$router.go(-1);
        return;
      }
      if (this.$route.query.teamId) {
        this.$router.push(`/teams/${this.$route.query.teamId}?tab=members`);
        return;
      }
      if (this.$route.params.squad) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: 'managements',
          params: {
            selectedTab: 'membermgmt'
          }
        });
      }
    },
    async lockUser() {
      const { id } = this.$route.params;
      this.$store.commit('loading', true);
      await this.$http.post(`/assemble/api/v1/admin/members/lock/${id}`, { isLocked: true });
      this.$set(this.member, 'isLocked', true);
      this.$message.success('Member has been locked successfully!');
      this.$store.commit('loading', false);
      this.$forceUpdate();
    },
    async unlockUser() {
      const { id } = this.$route.params;
      this.$store.commit('loading', true);
      await this.$http.post(`/assemble/api/v1/admin/members/lock/${id}`, { isLocked: false });
      this.$set(this.member, 'isLocked', false);
      this.$message.success('Member has been unlocked successfully!');
      this.$store.commit('loading', false);
      this.$forceUpdate();
    },
    getBase64Logo() {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        img.onerror = (error) => {
          reject(error);
        };
        img.src = `${ process.env.VUE_APP_LOGO }?r=${ Math.floor(Math.random() * 100000)}`;
      });
    },
    async downloadPDF() {
      const { member, registrations } = this;
      let isURL = false;
      let imageContent;

      if (process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '') {
        isURL = true;
      }

      if (isURL) {
        imageContent = await this.$http.post('/assemble/api/v1/admin/members/download-content', { logo: process.env.VUE_APP_LOGO, isURL });
      }

      const memberHeader = {
        text: 'Member Details',
        style: 'headerText'
      };

      const memberContent = {
        ul: [
          { text: `Member ID: ${_.get(member, '_id', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `First Name: ${_.get(member, 'profile.firstName', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Middle Name: ${_.get(member, 'profile.middleName', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Last Name: ${_.get(member, 'profile.lastName', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Short Name: ${_.get(member, 'profile.abbreviation', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Preferred Name: ${_.get(member, 'profile.preferredName', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Mobile: ${_.get(member, 'profile.mobile', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Email: ${_.get(member, 'profile.email', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `DOB: ${_.get(member, 'profile.dob', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Gender: ${_.get(member, 'profile.gender', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Nationality: ${_.get(member, 'profile.nationality', '')}`, style: 'largeText', markerRadius: 10 },

          { text: `Address Line 1: ${_.get(member, 'profile.address.addressLine1', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Address Line 2: ${_.get(member, 'profile.address.addressLine2', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Suburb: ${_.get(member, 'profile.address.suburb', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `State: ${_.get(member, 'profile.address.state', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Post Code: ${_.get(member, 'profile.address.postcode', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Country: ${_.get(member, 'profile.address.country', '')}`, style: 'largeText', markerRadius: 10 },

          { text: `Emergency Name: ${_.get(member, 'profile.emebergency.name', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Emergency Mobile: ${_.get(member, 'profile.emergency.mobile', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Relationship: ${_.get(member, 'profile.emergency.relationship', '')}`, style: 'largeText', markerRadius: 10 },

          { text: `Parent Name: ${_.get(member, 'profile.meta.parentOrGuardian1.name', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Parent Email: ${_.get(member, 'profile.meta.parentOrGuardian1.email', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Parent Mobile: ${_.get(member, 'profile.meta.parentOrGuardian1.mobile', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Parent Phone: ${_.get(member, 'profile.meta.parentOrGuardian1.phone', '')}`, style: 'largeText', markerRadius: 10 },

          { text: `Number: ${_.get(member, 'profile.meta.wwc.number', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Expiry: ${_.get(member, 'profile.meta.wwc.expiry', '')}`, style: 'largeText', markerRadius: 10 },
          { text: `Issuer: ${_.get(member, 'profile.meta.wwc.issuer', '')}`, style: 'largeText', markerRadius: 10 },

        ],
        margin: [180, 0, 0, 0]
      };

      const client = _.find((clientsAdditionalDetails), (c) => c.nationalId === this.currentNationalId);
      _.forEach((_.get(client, 'details')), (detail) => {
        const labelValue = _.get(member, detail.field, '');
        let text = labelValue;
        if (detail.field === 'meta.homeClub') text = _.get(labelValue, 'name') || _.get(labelValue, 'value');
        if (detail.field === 'meta.clubs') text = _.join(_.map(labelValue, (val) => val.name), ', ');
        if (detail.field === 'meta.coachesEmails') text = _.join(labelValue, ', ');
        memberContent.ul.push({ text: `${detail.label}: ${text}`, style: 'largeText', markerRadius: 10 });
      });

      const regoHeader = {
        text: 'Registration History',
        style: 'headerText'
      };
      const regoContent = {
        table: {
          headerRows: 1,
          // widths: Array(15).fill(`${100 / 15 }%`),
          widths: Array(12).fill('auto'),
          body: [
            [
              { text: 'Reg ID', style: 'smallText' },
              { text: 'Entity Name', style: 'smallText' },
              { text: 'Entity Type', style: 'smallText' },
              { text: 'Product Type', style: 'smallText' },
              { text: 'Member Type', style: 'smallText' },
              { text: 'Team', style: 'smallText' },
              { text: 'Club', style: 'smallText' },
              { text: 'Assn', style: 'smallText' },
              { text: 'Season', style: 'smallText' },
              { text: 'Expired', style: 'smallText' },
              { text: 'Deregistered', style: 'smallText' },
              { text: 'Date Purchased', style: 'smallText' },
            ],
            ...registrations.map((rego) => ([
              { text: _.get(rego, '_id', ''), style: 'smallText' },
              { text: _.get(rego, 'regoEntity.name', ''), style: 'smallText' },
              { text: _.get(rego, 'entityType', ''), style: 'smallText' },
              { text: this.getProductType(_.get(rego, 'productType', '')), style: 'smallText' },
              { text: _.get(rego, 'memberType', ''), style: 'smallText' },
              { text: _.get(rego, 'team.name', ''), style: 'smallText' },
              { text: _.get(rego, 'orgtree.club.name', ''), style: 'smallText' },
              { text: _.get(rego, 'orgtree.association.name', ''), style: 'smallText' },
              { text: _.get(rego, 'season', ''), style: 'smallText' },
              { text: _.get(rego, 'expired', false) ? 'Yes' : 'No', style: 'smallText' },
              { text: _.get(rego, 'deregistered', false) ? 'Yes' : 'No', style: 'smallText' },
              { text: this.formatDate(_.get(rego, 'createdAt', '')), style: 'smallText' },
            ]))
          ]
        },
        style: 'table',
      };

      const teamsHeader = {
        text: 'Teams',
        style: 'headerText'
      };
      const teamContent = {
        table: {
          headerRows: 1,
          // widths: Array(7).fill(`${100 / 7 }%`),
          widths: Array(7).fill('auto'),
          body: [
            [
              { text: 'ID', style: 'smallText' },
              { text: 'Team', style: 'smallText' },
              { text: 'Member Type', style: 'smallText' },
              { text: 'Club', style: 'smallText' },
              { text: 'Association', style: 'smallText' },
              { text: 'State', style: 'smallText' },
              { text: 'Manually Added', style: 'smallText' },
            ],
            ...this.teams.map((team) => ([
              { text: _.get(team, '_id', ''), style: 'smallText' },
              { text: _.get(team, 'name', ''), style: 'smallText' },
              { text: _.get(team, 'member.memberType', ''), style: 'smallText' },
              { text: _.get(team, 'orgtree.club.name', ''), style: 'smallText' },
              { text: _.get(team, 'orgtree.associate.name', ''), style: 'smallText' },
              { text: _.get(team, 'orgtree.state.name', ''), style: 'smallText' },
              { text: _.get(team, 'member.manual', false) ? 'Yes' : 'No', style: 'smallText' },
            ]))
          ]
        },
        margin: [100, 0, 0, 0]
      };

      const accreditationHeader = {
        text: 'Accreditations',
        style: 'headerText'
      };
      const accreditationContent = {
        table: {
          headerRows: 1,
          // widths: Array(5).fill(`${100 / 5 }%`),
          widths: Array(5).fill('auto'),
          body: [
            [
              { text: 'Accreditation', style: 'smallText' },
              { text: 'Description', style: 'smallText' },
              { text: 'Expiry', style: 'smallText' },
              { text: 'Active', style: 'smallText' },
              { text: 'Date Issued', style: 'smallText' },
            ],
            ...this.accreditations.map((accreditation) => ([
              { text: _.get(accreditation, 'accreditation.name', ''), style: 'smallText' },
              { text: _.get(accreditation, 'accreditation.description', ''), style: 'smallText' },
              { text: this.formatDate(_.get(accreditation, 'expiry', '')), style: 'smallText' },
              { text: _.get(accreditation, 'isActive', false) ? 'Yes' : 'No', style: 'smallText' },
              { text: this.formatDate(_.get(accreditation, 'createdAt', '')), style: 'smallText' },
            ])),
          ],
        },
        margin: [50, 0, 0, 0]
      };

      // const widths = Array(3 + this.scoringEvents.concat(this.playerMovements).length).fill(`${100 / (3 + this.scoringEvents.concat(this.playerMovements).length) }%`);
      const widths = Array(3 + this.scoringEvents.concat(this.playerMovements).length).fill('auto');
      const headers = [
        [...[
          { text: 'Round', style: 'smallText' },
          { text: 'Match', style: 'smallText' },
          { text: 'Award', style: 'smallText' },
        ],
        ...this.scoringEvents.concat(this.playerMovements).map((e) => ({ text: e.abbreviation || e.name, style: 'smallText' }))
        ]
      ];
      const body = [
        ...this.filteredPerformances.map((filtered) => ([
          { text: filtered.round.name || filtered.round.number, style: 'smallText' },
          { text: `${_.get(filtered, 'homeTeam.name', 'NA')}(${filtered.scores.homeTeam}) vs (${filtered.scores.awayTeam})${_.get(filtered, 'awayTeam.name', 'NA')}`, style: 'smallText' },
          { text: this.getPlayerOfTheMatch(filtered), style: 'smallText' },
          ...this.scoringEvents.concat(this.playerMovements).map((e, index) => ({ text: this.generateStat([filtered])[index].total, style: 'smallText' }))
        ])),
        ...[[
          { text: 'Total', style: 'smallText' },
          { text: '', style: 'smallText' },
          { text: '', style: 'smallText' },
          ...this.generateStat(this.filteredPerformances).map((s) => ({ text: s.total, style: 'smallText' }))]]
      ];

      const performanceHeader = {
        text: 'Performance',
        style: 'headerText'
      };
      const performanceContent = {
        table: {
          // headerRows: 1,
          widths,
          body: [
            ...headers,
            ...body
          ]
        },
        style: 'table',
        margin: this.scoringEvents.concat(this.playerMovements).length === 0 ? [200, 0, 0, 0] : [0, 0, 0, 0]
      };

      const content = [];
      const finalContent = [];

      if (_.get(this, 'download.details')) content.push([memberHeader, memberContent]);
      if (_.get(this, 'download.regoHistory')) content.push([regoHeader, regoContent]);
      if (_.get(this, 'download.teams')) content.push([teamsHeader, teamContent]);
      if (_.get(this, 'download.accreditations')) content.push([accreditationHeader, accreditationContent]);
      if (_.get(this, 'download.performance')) content.push([performanceHeader, performanceContent]);

      _.forEach((content), (c, i) => {
        if (i !== content.length - 1) content[i][1].pageBreak = 'after';
        finalContent.push(...content[i]);
      });

      finalContent.unshift(imageContent.data.data.imageContent);

      const dd = {
        content: finalContent,
        styles: {
          tableStyle: {
            fontSize: 8 // set the smallest text size here
          },
          smallText: {
            fontSize: 7
          },
          largeText: {
            fontSize: 14
          },
          headerText: {
            fontSize: 20,
            bold: true,
            alignment: 'center',
            margin: [0, 20, 0, 10]
          },
          tableHeader: {
            bold: true,
            fillColor: '#eeeeee'
          },
          tableAccreditations: {
            margin: [0, 150, 150, 10]
          }
        },
      };

      if (pdfMake.vfs === undefined) {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      pdfMake.createPdf(dd).download(`${member._id}.pdf`);
    },
    getProductType(productType) {
      if (productType === 'indv') return 'Individual';
      if (productType === 'indv-to-team') return 'Individual To Team';
      if (productType === 'team') return 'Team';

      return '';
    },
    handleClose() {
      this.downloadDialog = false;
    },
    async loadTeams(_id) {
      const res = await this.$http.get(`assemble/api/v1/admin/members/${_id}/teams`);
      this.teams = res.data.data;
    },
    async loadAccreditations(_id) {
      const res = await this.$http.get(`assemble/api/v1/admin/members/${_id}/accreditations`);
      this.accreditations = res.data.data;
    },
    async loadPerformances(_id) {
      this.$store.commit('loading', true);
      const res = await this.$http.get(`/assemble/api/v1/admin/members/${_id}/performances`);
      this.performances = res.data.data;
      const resByPlayer = await this.$http.get(`/assemble/api/v1/admin/competition-settings/get-by-player/${_id}`);
      let allMatchStatuses = [];
      let allScoringEvents = [];
      let allPlayerMovements = [];
      const matchStatuses = [];
      const scoringEvents = [];
      const playerMovements = [];
      const competitionSettings = _.get(resByPlayer, 'data.data');
      competitionSettings.forEach((cs, i) => {
        const csMatchStatuses = cs.matchStatuses;
        const csScoringEvents = cs.scoringEvents;
        const csPlayerMovements = cs.playerMovements;
        allMatchStatuses = [...allMatchStatuses, ...csMatchStatuses];
        allScoringEvents = [...allScoringEvents, ...csScoringEvents];
        allPlayerMovements = [...allPlayerMovements, ...csPlayerMovements];
      });

      allMatchStatuses.forEach((ms, i) => {
        if (!_.find(matchStatuses, (m) => m.label === ms.label && m.value === ms.value)) {
          matchStatuses.push(ms);
        }
      });
      allScoringEvents.forEach((se, i) => {
        if (!_.find(scoringEvents, (s) => s.name === se.name && s.type === se.type && s.value === se.value)) {
          scoringEvents.push(se);
        }
      });
      allPlayerMovements.forEach((pm, i) => {
        if (!_.find(playerMovements, (p) => p.name === pm.name && p.type === pm.type)) {
          playerMovements.push(pm);
        }
      });

      this.scoringEvents = scoringEvents;
      this.playerMovements = playerMovements;
      this.$store.commit('loading', false);
    },
    teamWin(row, type) {
      if (type === 'home') {
        return row.scores.homeTeam > row.scores.awayTeam;
      }
      return row.scores.homeTeam < row.scores.awayTeam;
    },
    getPlayerOfTheMatch(row) {
      if (row.playerOfTheMatch && row.playerOfTheMatch.length) {
        const foundAward = row.playerOfTheMatch.find((p) => p._id === this.member._id);
        if (foundAward) return `${foundAward.name} - ${foundAward.value} point`;
      }
      return '';
    },
    generateStat(matches) {
      const { scoringEvents, playerMovements } = this;
      const playerId = +this.$route.params.id;
      const matchesWithPlayer = matches.filter((m) => m.scoringEvents.some((e) => e.meta && e.meta.player && e.meta.player._id === playerId));
      const matchesWithPlayerMovements = matchesWithPlayer.filter((m) => m.playerMovements.some((e) => e.meta && e.meta.player && e.meta.player._id === playerId));
      const scorings = scoringEvents.reduce((acc, event) => {
        const { type, name: eventName } = event;
        const total = matchesWithPlayer.reduce((ac, match) => {
          const { scoringEvents: matchScoringEvents } = match;
          const eventTotal = matchScoringEvents.filter((e) => e.type === type && e.meta && e.meta.player && e.meta.player._id === playerId).length;
          return ac + eventTotal;
        }, 0);
        return acc.concat({ type, total, eventName });
      }, []);
      const movements = playerMovements.reduce((acc, event) => {
        const { type, name: eventName } = event;
        const total = matchesWithPlayerMovements.reduce((ac, match) => {
          const { playerMovements: matchPlayerMovements } = match;
          const eventTotal = matchPlayerMovements.filter((e) => e.type === type && e.meta && e.meta.player && e.meta.player._id === playerId).length;
          return ac + eventTotal;
        }, 0);
        return acc.concat({ type, total, eventName });
      }, []);
      return scorings.concat(movements);
      // return scorings;
    },
    formatDate(val) {
      if (val) return moment(val).format('DD MMM YYYY');
      return '';
    },
  },
  computed: {
    clearance() {
      return this.$store.getters['user/activeRoleType'];
    },
    filteredPerformances() {
      return this.performances;
    },
    currentNationalId() {
      return +process.env.VUE_APP_NATIONAL_ID;
    },
  },
};
</script>
<style lang="scss" scoped>
.btn {
  margin-right: 15px;
}
::v-deep .btn .el-button {
  min-width: 8rem;
  height: 38px;
}
</style>
